<template>
    <div
        class="banner-button-v2"
        :class="'count-' + renderButtons.length"
        v-if="renderButtons?.length > 0"
    >
        <a
            v-for="(button, index) in renderButtons"
            :key="button.link + '-' + index"
            :href="button.type === 'callback' ? null : button.link"
            class="btn-item"
            :class="{ plain: button.plain }"
            rel="noopener noreferrer"
            :target="button.target || '_blank'"
            :aria-label="getButtonLabel(button)"
            @click="click(button)"
            :style="getStyle(button)"
        >
            <span class="button-text" v-if="showText" v-html="getButtonLabel(button)"></span>
            <i :class="['iconfont', arrowIcon]" v-show="showArrow"></i>
        </a>
    </div>
</template>

<script>
import { getButtonHtmlStyle } from '@/common/utils/decode-html';
export default {
    emits: ['callback'],
    props: {
        size: {
            type: Number,
            default: 0
        },
        buttons: {
            type: Array,
            default: () => []
        },
        showArrow: {
            type: Boolean,
            default: false
        },
        showText: {
            type: Boolean,
            default: true
        },
        arrowIcon: {
            type: String,
            default: 'icon-arrow-up'
        }
    },
    computed: {
        renderButtons() {
            const buttons = [];
            this.buttons.forEach(item => {
                const text = this.getButtonLabel(item);
                if (text || (!this.showText && this.showArrow)) {
                    buttons.push(item);
                }
            });
            return buttons;
        }
    },
    methods: {
        getButtonLabel(button) {
            let text =
                button.label ||
                button.text ||
                (button.textOption &&
                    (button.textOption?.text || button.textOption?.html)) ||
                '';
            return text.replace(/<[^>]*>/g, '');
        },
        click(button) {
            //  If there is type field and not 'url' when type ， Instead callback ， For example, click the button to pop up the registration box
            if (button && button.type && button.type === 'callback') {
                this.$emit('callback', button);
            }
        },
        getStyle(button) {
            let style = '';
            switch (button.plain) {
            case true:
                style = {
                    color: button.color,
                    borderColor: button.color,
                    backgroundColor: 'transparent'
                };
                break;
            case false:
                style = {
                    color: button.textColor,
                    backgroundColor: button.color,
                    borderColor: button.color
                };
                break;
            default:
                style = {
                    color: button.textColor,
                    backgroundColor: button.color,
                    borderColor: button.borderColor || button.color
                };
                break;
            }
            if (this.showText) {
                style = { ...style, ...getButtonHtmlStyle(button) };
            }
            return style;
        }
    }
};
</script>

<style lang="scss">
@import '../theme/media.scss';
@import '../theme/mixin.scss';
.banner-button-v2 {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .btn-item {
        position: relative;
        margin: 10px 5px 0 5px;
        padding: 0 20px;
        min-width: 190px;
        overflow: hidden;
        height: 40px;
        line-height: 38px;
        display: block;
        text-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        font-size: 12px;
        font-weight: 500;
        font-family: var(--mg-button-font);
        text-align: center;
        border: 1px solid;
        @include color-button-v2();
        @include color-button-hover();
        .icon-arrow-up {
            transform: rotate(90deg);
            display: inline-block;
            font-size: 14px;
        }
        &.plain {
            border-color: var(--g-btn-background, #fff);
            color: var(--g-btn-background, #fff);
        }
    }
    .btn-item {
        cursor: pointer;
    }
}
</style>
